import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/components/Dashboard';
import ProjectDashboard from '@/components/ProjectDashboard';
import Domains from '@/components/Domains';
import Emails from '@/components/Emails';
import Databases from '@/components/Databases';
import Marketing from '@/components/Marketing';
import Advanced from '@/components/Advanced';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(Element);

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: { title: 'webhorsting > home' },
    },
    {
      path: '/project',
      name: 'project-dashboard',
      component: ProjectDashboard,
      meta: { title: 'webhorsting > project' },
    },
    {
      path: '/domains',
      name: 'projects',
      component: Domains,
      meta: { title: 'webhorsting > domains' },
    },
    {
      path: '/emails',
      name: 'emails',
      component: Emails,
      meta: { title: 'webhorsting > emails' },
    },
    {
      path: '/databases',
      name: 'databases',
      component: Databases,
      meta: { title: 'webhorsting > databases' },
    },
    {
      path: '/marketing',
      name: 'marketing',
      component: Marketing,
      meta: { title: 'webhorsting > marketing' },
    },
    {
      path: '/advanced',
      name: 'advanced',
      component: Advanced,
      meta: { title: 'webhorsting > advanced' },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js